/*
 * @Description: 数据ready或者生命周期钩子函数触发事件
 * @Version: 1.0
 * @Autor: Kyle
 * @Date: 2022-08-23 14:40:09
 * @LastEditTime: 2023-02-07 17:36:15
    onReadyOrActive(isReady, () => {
    }, () => {
    })
 */

export default (isReady: Ref<boolean>, onHook: () => void, offHook: () => void) => {
  // 避免首次进入watch和mounted,onActivated重复执行
  let isInit = false
  const on = () => {
    if (!isReady.value || isInit) return
    isInit = true
    onHook && onHook()
  }
  const off = () => {
    offHook && offHook()
    isInit = false
  }

  watch(() => isReady.value, on, { immediate: true })
  onMounted(on)
  onActivated(on)
  onBeforeUnmount(off)
  onDeactivated(off)
}
